var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { FreeHtml } from "sb-resp-ui";
import Debounce from "debounce-decorator";
export class RibbonMessage extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.boundOwnResizeHandler = this.ownResizeHandler.bind(this);
    }
    componentDidMount() {
        window.addEventListener("resize", this.boundOwnResizeHandler);
        this.ownResizeHandler();
    }
    /* istanbul ignore next */
    componentDidUpdate(prevProps) {
        if (this.props.message !== prevProps.message) {
            this.ownResizeHandler();
        }
    }
    /* istanbul ignore next */
    componentWillUnmount() {
        window.removeEventListener("resize", this.boundOwnResizeHandler);
    }
    ownResizeHandler() {
        this.ref.current && this.ref.current.firstElementChild && this.props.resizeHandler(this.ref.current.clientWidth, this.ref.current.firstElementChild.scrollWidth);
    }
    /* istanbul ignore next */
    render() {
        return (React.createElement("div", { ref: this.ref, className: this.props.className, onClick: (e) => this.props.handler(e) },
            React.createElement(FreeHtml, { html: this.props.message })));
    }
}
__decorate([
    Debounce(50),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], RibbonMessage.prototype, "ownResizeHandler", null);
//# sourceMappingURL=RibbonMessage.js.map